import '../../App.less';
import {Radio, Comment,Avatar,Layout, Select,Badge, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space, Button ,notification,AutoComplete, Card } from 'antd';
import React, { Component } from "react";
import es_ES from 'antd/lib/locale/es_ES';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,CalendarOutlined,EditOutlined,TagsOutlined,FileTextOutlined,FilePdfOutlined, AuditOutlined,QrcodeOutlined } from '@ant-design/icons';
import moment from 'moment'
import axios from "axios";
import {getAuthors,getAuthorsStr,IP,countDownNotification, downloadFile, readFile, getComments} from '../components/utils';
import Foot from "../components/Footer"
import JuryMenu from "../components/JuryMenu"

class Playslist extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      plays:[],
      showArticle:false,
      record:null,
      edit:false,
      categoryChanged:"",
      name:'',
      juryId:undefined,
      showCommentSection:false,
      comment:{},
      jurys_dict:{},
      edit_comment:undefined,
      selected_comment:undefined,
      comment_new_text:undefined,
      loaded_table_data:false,
      qualifications_dict:{},
      qualifications_changed:{},
    }
  }

  async componentWillMount() {
    //Jury
    const response_jury= await fetch(IP + 'api/casa/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_jury = await response_jury.json();
    if(json_jury['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    const jury_user = localStorage.getItem("User")
    const current_jury = json_jury.filter(j=>j.usuario.toLowerCase() ==jury_user.toLowerCase())[0]
    const jurys_dict={}
    Object.entries(json_jury).forEach(element => {
      jurys_dict[element[1].id]=element[1]
    });

    //Genre
    const genre = await fetch(IP + 'api/casa/genero/');
    this.json_g = await genre.json();
    this.genres_dict = {};
    this.json_g.forEach(element => {
      this.genres_dict[element.id] = element.nombre
    });

    //Qualifications
    var qual_url = new URL(IP + 'api/casa/calificacion/')
    const qualifications = await fetch(qual_url,{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_qualifications = await qualifications.json()
    const qualifications_dict={}
    json_qualifications.forEach(element => {
      if(element.jurado == current_jury.id)
        qualifications_dict[element.obra] = element
    });
   

    //Plays
    const response_plays = await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_plays = await response_plays.json();
    
    var data = []
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    
    const Moment = require('moment');
    var new_comments={}
    for(var i in json_plays){
      var item = json_plays[i];
      new_comments[item.id] = 0
      if(!item.preseleccionada)
        continue
      
      if(item.genero != jurys_dict[current_jury.id].genero && this.genres_dict[jurys_dict[current_jury.id].genero] != 'Admin'){
        continue
      }
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo)
      const year = date.split('-')[2]
      this.codes.add(year+'_'+item.genero+'_'+item.id);
      data.push(
          { 
            id : item.id,
            title : item.titulo,
            author: author ,
            authorStr:authorStr,
            date:date,
            pseudo: item.pseudonimo,
            code:year+'_'+item.genero+'_'+item.id,
            conc:item.conc,
            pdf:item.pdf,
            category:this.genres_dict[item.genero],
            categoryObj:{id:item.genero, nombre:this.genres_dict[item.genero] },
            pdf:item.pdf,
            edit:''
          });
    };
    data.sort((a,b)=>(qualifications_dict[a.id]?.puntaje == 2  && qualifications_dict[b.id]?.puntaje != 2) ? -1000 : (qualifications_dict[a.id]?.puntaje != 2 && qualifications_dict[b.id]?.puntaje == 2  ? 1000 : (jurys_dict[current_jury.id].obras.includes(a.id) && !jurys_dict[current_jury.id].obras.includes(b.id) ? -500 :(!jurys_dict[current_jury.id].obras.includes(a.id) && jurys_dict[current_jury.id].obras.includes(b.id)? 500 : a.id< b.id ? -1 : 1))))
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    //Last Access to Comments
    const last_comments_access = await fetch(IP + `api/casa/acceso_comentario/?jurado=${current_jury.id}`,{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_last_comments_access = await last_comments_access.json()
    const last_comments_acces = {}
    json_last_comments_access.forEach(access => {
      last_comments_acces[access.obra] = new Moment(access.fecha).format()
    });

    //Comments
    const comments = await fetch(IP + `api/casa/comentario/`,{ method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"}})
    const json_comments = await comments.json();
    json_comments.forEach(c=>{
      if(!last_comments_acces[c.obra] || moment(c.fecha).isAfter(last_comments_acces[c.obra])){
        new_comments[c.obra] =  new_comments[c.obra] + 1
      }
    })
    this.setState({ user:jury_user,juryId:current_jury.id, name:current_jury.nombre_completo, jurys_dict:jurys_dict,plays: data ,loaded_table_data:true, qualifications_dict:qualifications_dict, new_comments:new_comments});
  }

  onClickArticle = record  => {
    this.setState({showArticle:true,record:record});
  };
  hideModal = () => {
    this.setState({showArticle: false,record: null });
  };

  hideEdit = () => {
    this.setState({edit: false,record: null});
  };
  async saveQualification(record_id){
    if (record_id in this.state.qualifications_changed){
      if(!(record_id in this.state.qualifications_dict)){//if it didn't exist, we have to post
        const data= new FormData()
        data.append('jurado',this.state.juryId)
        data.append('obra',record_id)
        data.append('puntaje',this.state.qualifications_changed[record_id])
        axios.post(IP + 'api/casa/calificacion/', data).then((res) => {
          countDownNotification(notification.success,'Completado','La calificación se guardó de forma exitosa','success')
        }).catch((err) => {
          notification.error({
            message:'Error',
            description:"Hubo un error. Intente mas tarde por favor",
          });
      })}
      else{//if it did exist, we have to patch
        var options = {
          method: "patch",
          credentials: "same-origin",
          headers: {
            "Authorization": localStorage.getItem("Authorization") ,
            "Accept": "application/json",
            "Content-Type": "application/json"},
        }
        var editedQualification = {
          puntaje: this.state.qualifications_changed[record_id]
        }
        await axios.patch(IP + `api/casa/calificacion/${this.state.qualifications_dict[record_id].id}/`, editedQualification, options)
        .then(
          (response) => {
          if(response.status === 200)
          countDownNotification(notification.success,'Completado','La calificación se guardó de forma exitosa','success')
          },
          (error) => {
            countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure")
          }
        ).catch((err) => countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure"))
      }
      var newqualifications_changed = {...this.state.qualifications_changed}
      delete newqualifications_changed[record_id]
      this.setState({qualifications_changed:{...newqualifications_changed}})
    }
  }

  onClickEditPlay(record){
    this.setState({edit:true,record:record});
  };
  onChangeSelect(value){
    this.setState({categoryChanged:value})
  }

  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    
    else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }
 
  async onClickSave(){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
    var playChanged={}
    playChanged={
      titulo: document.getElementById("inputTitle").value,
      genero: this.state.categoryChanged? this.state.categoryChanged:this.state.record.category=="Novela"? 1:this.state.record.category=="Poesía"?2:3,
      pseudonimo: document.getElementById("inputPseudo").value
    }

    this.state.record.author.map(async(i,index)=>{
      var editedAuthor={
        nombre_completo: document.getElementById("author"+i.id).value
      }
      await axios.patch(IP + `api/concursantes/${i.id}/`, editedAuthor, options)
      .then(
        (response) => {
        if(response.status === 200)
          console.log("OK")
        },
        (error) => {
          console.log(error);
        }
      ).catch((err) => console.log(err))
    })
   
   await axios.patch(IP + `api/casa/obra/${this.state.record.id}/`, playChanged, options)
   .then(
     (response) => {
       if(response.status === 200)
          window.location.reload()
        else{
          notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
          })
        }
     },
     (error) => {
       console.log(error);
     }).catch((err) => console.log(err))
  }
 
  async postComment(play_id,parentComment){
    const data= new FormData()
    data.append('jurado',this.state.juryId)
    data.append('obra',play_id)
    data.append('texto',this.state.comment_new_text)
    if(parentComment){
      data.append('comentario_padre',parentComment)
    }
    axios.post(IP + 'api/casa/comentario/', data).then(async (res) => {
      if (res.status == 200){
        const comments_dict = await getComments(play_id)
        this.setState({comment:comments_dict,selected_comment:undefined,answer_comment:false, comment_new_text:''})
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }

  async saveEditComment(play_id,commentId){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
    }
    var editedComment = {
      texto: this.state.comment_new_text
    }
    await axios.patch(IP + `api/casa/comentario/${commentId.toString()}/`, editedComment, options)
    .then(
      async(response) => {
       if(response.status === 200)
       var comments_dict = await getComments(play_id)
       this.setState({comment:comments_dict,edit_comment:false,selected_comment:undefined, comment_new_text:undefined},()=>countDownNotification(notification.success,'Completado','El mensaje se guardó de forma exitosa','success'))
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  
  async deleteComment(play_id,commentId){
    fetch(IP + `api/casa/comentario/${commentId.toString()}/`,{
      method:'DELETE',
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }).then(async (res) => {
      if (res.status == 204){
        var comments_dict = await getComments(play_id)
        this.setState({comment:comments_dict},()=>countDownNotification(notification.success,'Completado','El mensaje se eliminó de forma exitosa','success'))
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }
  editComment(comment){
    this.setState({edit_comment:true,selected_comment:comment.id, comment_new_text:comment.texto})
  }
  cancelComment(){
    this.setState({edit_comment:false,selected_comment:undefined,answer_comment:false, comment_new_text:''})
  }
  answerComment(commentId){
    this.setState({selected_comment:commentId,answer_comment:true,edit_comment:false})
  }
  
  getChildComments(comment){
    const { TextArea } = Input;
    return (this.state.edit_comment && this.state.selected_comment == comment.id &&
      <Comment
        actions={[<span onClick={()=>this.saveEditComment(comment.obra,comment.id)} >Guardar</span>, <span onClick={()=>this.cancelComment()} >Cancelar</span>]}
        avatar={
          <Avatar
            src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
            alt={this.state.jurys_dict[comment.jurado].nombre_completo}
          />
        } 
        content={
          <TextArea value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
        }
      >
        {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
        })}
      </Comment>
          
      || (this.state.answer_comment && this.state.selected_comment == comment.id &&
      <Comment
        actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)}>Editar</span>,<span onClick={()=>this.deleteComment(comment.obra, comment.id)} >Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)} >Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}>Responder</span>]}
        author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
        avatar={
          <Avatar
            src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
            alt={this.state.jurys_dict[comment.jurado].nombre_completo}
          />
        }
        content={<p>{comment.texto}</p>}
        datetime={
            <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
        }
      >      
        <Comment
          actions={[<Button type="primary" disabled={!this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""}  onClick={()=>this.postComment(this.state.currentRecordId,comment.id)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
          avatar={
            <Avatar
              src={`https://ui-avatars.com/api/name=${this.state.name}&background=random`}
              alt={this.state.name}
            />
          }
          content={
            <TextArea placeholder="Escriba " value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
          }
        > 
        </Comment>
        {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
        })}
      </Comment>
      ) ||
      <Comment
        actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)} key="comment-basic-edit-to">Editar</span>,<span  onClick={()=>this.deleteComment(comment.obra, comment.id)}  key="comment-basic-delete-to">Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]}
        author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
        avatar={
          <Avatar
            src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
            alt={this.state.jurys_dict[comment.jurado].nombre_completo}
          />
        }
        content={<p>{comment.texto} </p>}
        datetime={
            <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
        }
      >
        {comment.respuestas.map(id => {
            return this.getChildComments(this.state.comment[id])
        })}
      </Comment>
    )
  }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}
            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>

           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large', backgroundColor: this.state.jurys_dict[this.state.juryId].obras.includes(record.id) ? '#d9d9d9': 'white' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.onClickArticle(record)} >{a.name}</a> </li>})}</ol> )
              || (text )  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({searchText: selectedKeys[0],searchedColumn: dataIndex});
      };
      async openComments(record){
        var comments_dict = await getComments(record ? record:this.state.record.id)
        this.setState({showCommentSection:true, currentRecordId:record ? record:this.state.record.id, comment:comments_dict})
      }
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
      onDocumentLoadSuccess({ numPages }) {
        this.setState({ numPages: numPages});
      };
      getDataFromURL = (url) => new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch(url)
                .then(response => response.text())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

  render() {
      const {  Content } = Layout;
      const Moment = require('moment');
      const columns = [
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
          dataIndex: 'code',
          key: 'code',
          width:150,
          ...this.getColumnSearchProps('code','número'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
          dataIndex: 'title',
          key: 'title',
          ...this.getColumnSearchProps('title','título'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
          dataIndex: 'pseudo',
          key: 'pseudo',
          ...this.getColumnSearchProps('pseudo','seudónimo'),
          responsive: ['sm'] 
        },
        {
          dataIndex:"pdf",
          key:"pdf",
          align:'center',
          width:95, 
          render: (text,record)=> {
            return {
              props: {
                style: { background: "white",fontSize:'large' }
              },
              children: <Button onClick={()=>readFile(text)}><FilePdfOutlined/> Leer</Button>
            }} 
        },
        {
          dataIndex:"id",
          key:"id",
          align:'center',
          width:130 ,
          render: (text,record)=> {
            return {
              props: {
                style: { background: "white",fontSize:'large',}
              },
              children:  
              <Button onClick={() => downloadFile(record)} ><FilePdfOutlined/>  Descargar</Button>
            }

        }},
        {
          dataIndex:"id",
          key:"id",
          align:'center',
          render: (text,record)=> {
            return {
              props: {
                style: { background:  "white",fontSize:'large',width:173 }
              },
              children:  
              <div> 
                <Badge size="small" count={this.state.new_comments[record.id]} overflowCount={100}>
                  <Button onClick={() => this.openComments(record.id)} ><FileTextOutlined />  Comentarios</Button>
                </Badge>
              </div>
            }} 
        },
        {
          title: <div style={{ fontWeight:'bold', fontSize:'large', textAlign:'center'}}>
          Calificación</div>,
          dataIndex: 'cal',
          key: 'cal',
          align:'right',
          width:399,
          render: (text,record)=> {
            return {
              props: {
                style: { background:'#d9d9d9',fontSize:'large' }
              },
              children:   
              <Radio.Group 
                defaultValue={this.state.qualifications_dict[record.id]?this.state.qualifications_dict[record.id].puntaje:undefined}
                onChange={(event)=>{
                  var new_qualifications={...this.state.qualifications_changed};
                  new_qualifications[record.id]=event.target.value
                  this.setState({qualifications_changed:{...new_qualifications}})}} 
              >
                <Space >
                  {this.state.jurys_dict[this.state.juryId].obras.includes(record.id) && <Radio style={{color:'red',borderBlockColor:'red'}} value={1}>Eliminada</Radio>}
                  <Radio style={{color:'#ffff80'}}  value={2}>Preseleccionada</Radio>
                  <Radio  disabled={!this.state.qualifications_dict[record.id] || this.state.qualifications_dict[record.id] && this.state.qualifications_dict[record.id].puntaje != 3} style={{color:'green',borderBlockColor:'green'}}  value={3}>Recomendada</Radio>
                </Space>
              </Radio.Group>
            }},  
          responsive: ['sm'] 
        },
        {
        dataIndex:"id",
        key:"id",
        align:'center',
        width:'84',
        render: (text,record)=> {
          return {
            props: {
              style: { background:  "#d9d9d9",fontSize:'large'}
            },
            children: <Button disabled={!(text in this.state.qualifications_changed)} onClick={()=>this.saveQualification(text)}>Guardar</Button>
          }} 
        },
      ];
   

    const closeComments=async ()=>{
      const Moment = require('moment');

      const data= new FormData()
      data.append('jurado',this.state.juryId)
      data.append('obra',this.state.currentRecordId)
      axios.post(IP + 'api/casa/acceso_comentario/', data).then(async (res) => {
        if (res.status == 200){
         console.log("OK")
        } 
        }).catch((err) => {
          console.log("ERROR")
      })
      const last_comments_access = await fetch(IP + `api/casa/acceso_comentario/?jurado=${this.state.juryId}`,{
        method: "get",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"
      },
      });
      const json_last_comments_access = await last_comments_access.json()
      const last_comments_acces = {}
      json_last_comments_access.forEach(access => {
        last_comments_acces[access.obra] = new Moment(access.fecha).format()
      });
      const comments = await fetch(IP + `api/casa/comentario/`,{ method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"}})
      const json_comments = await comments.json();
      var new_comments = {}
      json_comments.forEach(c=>{
        if(!last_comments_acces[c.obra] || moment(c.fecha).isAfter(last_comments_acces[c.obra])){
          new_comments[c.obra] =  new_comments[c.obra]?  new_comments[c.obra] + 1 : 1
        }
       
      })
      this.setState({showCommentSection:false,editComment:false, selected_comment:undefined,new_comments:new_comments})
    }
    const { TextArea } = Input;
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <JuryMenu defaultSelectedKey = {"plays"} name ={this.state.name}/>
              <Content>
                <Card style={{backgroundColor:'#d9d9d9'}}>
                  <Row justify="center" align="middle">
                    <Col span={22}>
                      <Table
                        loading={!this.state.loaded_table_data}
                        columns={columns}
                        dataSource= {this.state.plays}
                        pagination={{ position: ["bottomCenter"],}} 
                        tableLayout='fixed'
                        size='small'
                        style={{ whiteSpace: 'normal'}}
                        onChange = {this.handleTableChange}
                      />
                    </Col>
                  </Row>
                </Card>
              {
                this.state.showArticle && 
                <Modal 
                    closable = {false}
                    title={ this.state.record.code}
                    visible={this.state.showArticle} 
                    onCancel={this.hideModal}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                        Regresar
                        </Button>,
                    ]}
                >
                  <p><FileTextOutlined />Título: {this.state.record.title}</p>
                  <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                  <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
                  <p><TagsOutlined />Género: 
                    {this.state.record.category} 
                  </p>
                  <p><AuditOutlined />Seudónimo: {this.state.record.pseudo} </p>
                  <p>
                    <Button onClick={readFile}><FilePdfOutlined/> Leer PDF</Button>
                    <Button onClick={downloadFile} >
                    <FilePdfOutlined/>  Descargar PDF
                      </Button>
                    <Button onClick={() => this.openComments()} ><FileTextOutlined />  Comentarios</Button>
                  </p>
                </Modal>
              || (this.state.edit && 
                <Modal 
                  closable = {false}
                  title={ this.state.record.code}
                  visible={this.state.edit} 
                  onCancel={this.hideEdit}
                  footer={[
                    <Button key="save" onClick={()=>this.onClickSave()}>
                    Guardar
                    </Button>,
                      <Button key="back" onClick={this.hideEdit}>
                      Regresar
                      </Button>,
                  ]}
                >
                  <p><FileTextOutlined />Título: <Input style={{width:'80%'}} defaultValue={this.state.record.title} id ="inputTitle" onChange/></p>
                  <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                  <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
                  <p><TagsOutlined />Género: 
                    <Select defaultValue={this.state.record.category} onChange={(value)=>this.onChangeSelect(value)}>
                      <Option value={1}>{"Novela"}</Option>
                      <Option value={3}>{"Poesia"}</Option>
                      <Option value={2}>{"Ensayo histórico-social"}</Option>
                    </Select>  
                  </p>
                  <p><AuditOutlined />Seudónimo: <Input defaultValue={this.state.record.pseudo}style={{width:'70%'}} id="inputPseudo"/></p>
                  <p>
                    <Button onClick={readFile}><FilePdfOutlined/> Leer PDF</Button>
                    <Button onClick={downloadFile} ><FilePdfOutlined/>  Descargar PDF </Button>
                  </p>
                </Modal>)}
                { this.state.showCommentSection && 
                  <Modal 
                    closable = {false}
                    title={ "Comentarios"}
                    visible={this.state.showCommentSection} 
                    width={580}
                    footer={[
                        <Button key="back" onClick={closeComments}>
                          Cerrar
                        </Button>,
                    ]}
                  >
                  <Row align="middle" justify="center" >
                    <Col span={24}>
                      <Comment
                        actions={[<Button disabled={this.state.edit_comment || this.state.answer_comment || !this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""} type="primary" onClick={()=>this.postComment(this.state.currentRecordId)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
                        avatar={
                            <Avatar
                              src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[this.state.juryId].nombre_completo}&background=random`}
                              alt={this.state.jurys_dict[this.state.juryId].nombre_completo}
                            />
                        }
                        content={
                          <TextArea disabled={this.state.edit_comment || this.state.answer_comment} placeholder={"Añadir comentario"} value={!this.state.edit_comment && !this.state.answer_comment && this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
                        }
                      />
                      {
                        Object.entries(this.state.comment).map(element=>{
                          if (!element[1].comentario_padre){
                            return this.getChildComments(element[1])
                          }
                        })
                      }
                    </Col>
                  </Row>
              </Modal>}
            </Content>
          </Layout>
        </ConfigProvider>
    </div>
    <Foot jury={true}/>
    </div>
    );
  }
}
export default Playslist;


